import type { DmInboxStatus } from '../../../services/dmNotifications';

export const DEFAULT_INBOX_STATUS: DmInboxStatus = 'open';

export function parseInboxStatus(raw: string | null): DmInboxStatus {
    return raw === 'closed' ? 'closed' : DEFAULT_INBOX_STATUS;
}

// Waiting and triage sorts mean nothing once closed (the backend reads them as latest).
export interface ClosedSortRule<S extends string> {
    openOnly: readonly S[];
    fallback: S;
}

export function sortForStatus<S extends string>(
    sort: S,
    status: DmInboxStatus,
    rule: ClosedSortRule<S>
): S {
    return status === 'closed' && rule.openOnly.includes(sort) ? rule.fallback : sort;
}
